<div class="sp-container">
  <form [formGroup]="carForm" (ngSubmit)="submitCarForm()">
    <div class="sp-container">
      <div class="sp-row">
        <div class="sp-col sp-col--12">
          <h2 class="heading-2">{{ id ? 'تعديل' : 'إضافة' }} سيارة</h2>
        </div>
        <div class="sp-col sp-col--4 sp-col-sm--12">
          <div class="sp-col sp-col--12">
            <!--manufacture-->
            <sp-select
              formControlName="manufacture"
              [items]="manufactureList"
              placeholder="الشركة المصنعة"
              (onSelectChange)="getModelsList($event)"
              [valueAsObject]="true"
              [closeOnSelect]="true"
            ></sp-select>
          </div>
          <div class="sp-col sp-col--12">
            <!--model-->
            <sp-select
              formControlName="carName"
              [items]="modelsList"
              placeholder="الموديل"
              [valueAsObject]="true"
              [closeOnSelect]="true"
            ></sp-select>
          </div>
          <div class="sp-col sp-col--12">
            <!--modelYear-->
            <sp-select formControlName="modelYear" [items]="yearItem" placeholder="سنة الصنع" [closeOnSelect]="true"></sp-select>
          </div>
          <div class="sp-col sp-col--12">
            <!--vinNumber-->
            <sp-input label="أدخل رقم الهيكل" name="vinNumber" formControlName="vinNumber"></sp-input>
          </div>
          <div class="sp-col sp-col--12">
            <sp-button [style]="carForm.valid ? 'primary' : 'disabled-style'" [disabled]="adding" type="submit">{{
              id ? 'تعديل' : 'إضافة'
            }}</sp-button>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>
